class AppConstantsModel {
    mainCategoryPathRoute: string;
}

export const AppConstants: AppConstantsModel = {
    mainCategoryPathRoute: 'CategoriaPrincipal' 
}